import { render } from "./CTA.vue?vue&type=template&id=2575d404"
const script = {}

import "./CTA.vue?vue&type=style&index=0&id=2575d404&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__